import ConstConfig from "@/config/ConstConfig";
import i18n from "@/i18n/index"
import { langList } from "@/services/api/account";

export function updateLanguage(localeLanguage,lVersion){
  //  重新加载语言包
  langList().then(res=>{
    let languages =  res.data.languages;
    i18n.setLocaleMessage(localeLanguage, languages)
    localStorage.setItem(ConstConfig.LOCAL_CONST.languages, JSON.stringify(languages));
    localStorage.setItem(ConstConfig.LOCAL_CONST.languageVersion, lVersion);
  })
}
